// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._Sw3W{cursor:pointer;display:flex;flex-direction:column;gap:.5rem;padding:1rem 1.25rem;position:relative;z-index:1}._Sw3W,._Sw3W:hover{color:inherit}.Uteiy{color:var(--anchore-color-gray-900);font-size:1.4rem;font-weight:700}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"option": `_Sw3W`,
	"identifier": `Uteiy`
};
module.exports = ___CSS_LOADER_EXPORT___;
